import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import ToastMessage from "../../utils/mui/righttoptoast";
import api from "../../api/api";
import { useSelector } from "react-redux";
import { Backdrop, CircularProgress } from "@mui/material";
import AddBoxIcon from '@mui/icons-material/AddBox';
import DrMadhuSign from "../../assets/imaging/madhusign.png";
import { allowedUsers } from '../allowedUsers';
import { MitralAorticValves, TricuspidPulmonicForm, TechnicalComments } from "./EchoComponent";

const EchoModal = ({ ismodal, setIsmodal, data }) => {
  const [showIsthmusComment, setShowIsthmusComment] = useState(false);
  const [showRtComment, setShowRtComment] = useState(false);
  const [showLtComment, setShowLtComment] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("error");
  const [prevExamData, setPrevExamData] = useState([]);
  const [loading, setLoading] = useState(false);
  const practiseid = window.getPracticeId();
  const formattedDOB = dayjs(data?.dob).format("DD-MM-YYYY");
  const userConfig = useSelector((state) => state.userconfig);

  const calculateAge = (dob) => {
    const birthDate = dayjs(dob);
    const today = dayjs();
    return today.diff(birthDate, "year");
  };

  const age = calculateAge(data?.dob);

  const mModeKeys = [
    { key: 'mvde', label: 'MV D-E' },
    { key: 'aodia', label: 'AO DIA' },
    { key: 'aoex', label: 'AO EX' },
    { key: 'ladim', label: 'LA DIM' },
    { key: 'rvdim', label: 'RV DIM' },
    { key: 'ivsthick', label: 'IVS THICK' },
    { key: 'ivsexcur', label: 'IVS EXCUR' },
    { key: 'pwthick', label: 'PW THICK' },
    { key: 'pwexcur', label: 'PW EXCUR' },
    { key: 'ladiadim', label: 'LV DIA DIM' },
    { key: 'lasysdim', label: 'LV SYS DIM' },
    { key: 'ef', label: 'EF (%)' }
  ];

  const [formData, setFormData] = useState({
    take: "",
    tape: "",
    examDate: dayjs().format("YYYY-MM-DD"),
    registeredby: "DR. MADHU PAMGANAMAMULA",
    technician: "ART MONTANA",
    history: "",
    mMode: {
      mvde: "", aodia: "", aoex: "", ladim: "", rvdim: "", ivsthick: "", ivsexcur: "", pwthick: "", pwexcur: "", ladiadim: "", lasysdim: "", ef: ""
    },
    mitral: { mM2D: 'WITHIN NORMAL LIMIT', regurge: 'NORMAL', stenosis: 'NORMAL', flowE: '', flowA: '', pressTime: '', pressDecelTime: '', mva: '' },
    aortic: { mM2D: 'WITHIN NORMAL LIMIT', regurge: 'NORMAL', stenosis: 'NORMAL', flow: '', maxPG: '', meanPG: '', ava: '' },
    tricuspid: { mM2D: 'WITHIN NORMAL LIMIT', regurge: 'NORMAL', flow: '', trGradient: '', paPressure: '' },
    pulmonic: { mM2D: 'WITHIN NORMAL LIMIT', regurge: 'NORMAL' },
    technicianComments: {
      trivialAorticInsufficiency: '',
      noWallMotionAbnormalities: '',
      normalEjectionFraction: '',
      normalVentricularThickness: '',
      normalDiastolicFunction: '',
      sizeChambers: '',
      pulmonaryPressure: '',
      pericardialEffusion: '',
      intracavitaryMass: '',
    }
  });

  // Reset form data
  const resetFormData = () => {
    setFormData({
      take: "",
      tape: "",
      examDate: dayjs().format("YYYY-MM-DD"),
      registeredby: "",
      technician: "",
      history: "",
      signoff: "",
      mMode: { mvde: "", aodia: "", aoex: "", ladim: "", rvdim: "", ivsthick: "", ivsexcur: "", pwthick: "", pwexcur: "", ladiadim: "", lasysdim: "", ef: "" },
      mitral: { mM2D: '', regurge: '', stenosis: '', flowE: '', flowA: '', pressTime: '', pressDecelTime: '', mva: '' },
      aortic: { mM2D: '', regurge: '', stenosis: '', flow: '', maxPG: '', meanPG: '', ava: '' },
      tricuspid: { mM2D: '', regurge: '', flow: '', trGradient: '', paPressure: '' },
      pulmonic: { mM2D: '', regurge: '' },
      technicianComments: {
        trivialAorticInsufficiency: '',
        noWallMotionAbnormalities: '',
        normalEjectionFraction: '',
        normalVentricularThickness: '',
        normalDiastolicFunction: '',
        sizeChambers: '',
        pulmonaryPressure: '',
        pericardialEffusion: '',
        intracavitaryMass: '',
      }
    });
  };

  // const handleChange = (e, section, name, value, type = null) => {
  //   const newValue = value || e?.target?.value;
  //   // Special handling for technicianComments
  // if (section === "technicianComments") {
  //   setFormData(prev => ({
  //     ...prev,
  //     technicianComments: {
  //       ...prev.technicianComments,
  //       [name]: {
  //         ...prev.technicianComments[name],
  //         [type]: newValue // 👈 dropdown OR text
  //       }
  //     }
  //   }));
  // }

  // // Normal sections
  // else if (["mMode", "mitral", "aortic", "tricuspid", "pulmonic"].includes(section)) {
  //     setFormData(prevState => ({
  //       ...prevState,
  //       [section]: {
  //         ...prevState[section],
  //         [name]: newValue
  //       }
  //     }));
  //   } else {
  //     setFormData(prevState => ({
  //       ...prevState,
  //       [name]: newValue
  //     }));
  //   }
  // };

const handleChange = (e, section, name, value = null, type = null) => {
  // Determine new value: checkbox uses e.target.checked
  const newValue =
    value ?? (e?.target?.type === "checkbox" ? e.target.checked : e?.target?.value);

  // TECHNICIAN COMMENTS (dropdown/text)
  if (section === "technicianComments") {
    setFormData(prev => ({
      ...prev,
      technicianComments: {
        ...prev.technicianComments,
        [name]: {
          ...prev.technicianComments[name],
          [type]: newValue // type can be "dropdown" or "text"
        }
      }
    }));
  }

  // SPECIAL SECTIONS
  else if (["mMode", "mitral", "aortic", "tricuspid", "pulmonic"].includes(section)) {
    setFormData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [name]: newValue
      }
    }));
  }

  // NORMAL FIELDS (including checkboxes)
  else {
    setFormData(prev => ({
      ...prev,
      [name]: newValue
    }));
  }
};

  const validateForm = () => {
    const errors = [];

    if (!formData.examDate) errors.push("Exam Date is required.");
    // if (!formData.history.trim()) errors.push("Patient History is required.");
    return errors;
  };

  const handleSave = async () => {
    const errors = validateForm();
    if (errors.length > 0) {
      setToastMessage(errors[0]);
      setToastSeverity("error");
      setOpenToast(true);
    } else {
      try {
        setIsLoading(true);
        const payload = {
          patient_id: data?.patientid,
          pat_name: `${data?.firstname} ${data?.lastname}`,
          pat_dob: data?.dob,
          examDate: formData.examDate,
          pat_age: age,
          pat_gender: data?.gender?.toUpperCase(),
          encounterid: data?.appointmentid,
          pathistory: formData.history,
          take: formData.take,
          tape: formData.tape,
          registeredby: formData.registeredby,
          technician: formData.technician,
          mMode: formData.mMode,
          mitral: formData.mitral,
          aortic: formData.aortic,
          tricuspid: formData.tricuspid,
          pulmonic: formData.pulmonic,
          technicianComments: formData.technicianComments,
          signoff: formData?.signoff || '',
        };

        const user = await api.get('/auth/me');
        const [year, month, day] = formData.examDate.split("-");
        const formattedDate = `${month}/${day}/${year}`;

        const response = await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/insert-db`, {
          "Worksheet_Type": "ECHO",
          "createdby": user?.username || '',
          "appurl": window.location.origin,
          "Exam_Date": formattedDate,
          "data": payload
        });

        if (response.status === 200) {
          const pdf = await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/generate-pdf`, {
            "filename": response?.data?.filename,      
            "worksheet_type":"ECHO",
            "appurl": window.location.origin,
            "documenttypeid": response?.data?.documenttypeid,
            "exam_date": formattedDate
          });

          setToastMessage("Form Submitted Successfully");
          setToastSeverity("success");
          setOpenToast(true);

          setTimeout(() => {
            resetFormData();
            setIsmodal(false);
          }, 1000);
        } else {
          setToastMessage(response.message);
          setToastSeverity("info");
          setOpenToast(true);
        }
      } catch (error) {
        console.log(error);
        setToastMessage("Something Went Wrong");
        setToastSeverity("error");
        setOpenToast(true);
      } finally {
        setIsLoading(false);
      }
    }
  };



const fetchdata = async () => {

  try {
   setLoading(true);
    const examtype = "ECHO";
    const response = await api.get(
      `/v1/${practiseid}/imaging/patient/${data.patientid}/get-previous-exam/${examtype}`
    );

    if (response?.status === 200 && response?.data?.length > 0) {
      console.log("Raw API Response for Previous Exams:", response.data);
      // const raw = response?.data[0] ? [response.data[0]] : [];
      const raw = response?.data?.map((exam) => {
        // Optionally, parse the JSON data inside each exam
        let parsedData = {};
        try {
          parsedData = JSON.parse(exam.data);
        } catch (err) {
          console.error("Failed to parse exam.data", err);
        }

        return {
          ...exam,
          parsedData,
        };
      }) || [];

      console.log("Parsed Previous Exam Data:", raw);
      setPrevExamData(raw);
      setLoading(false);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    setLoading(false);
  }
};

useEffect(() => {
  if (ismodal) {
    fetchdata();
  }
}, [ismodal]);

const handleFillFields = (examData) => {
  if (!examData) return;

  // Parse if examData is a JSON string
  const parsedData = typeof examData === "string" ? JSON.parse(examData) : examData;

  setFormData((prev) => {
    const newFormData = { ...prev };

    // Fill top-level fields
    const topLevelFields = ['take', 'tape', 'examDate', 'registeredby', 'technician', 'history'];
    topLevelFields.forEach(field => {
      if (parsedData[field] !== undefined) {
        newFormData[field] = parsedData[field];
      }
    });

    // Fill M-Mode table
    if (parsedData.mMode) {
      newFormData.mMode = { ...parsedData.mMode };
    }

    // Fill Valve sections
    ['mitral', 'aortic', 'tricuspid', 'pulmonic'].forEach(valve => {
      if (parsedData[valve]) {
        newFormData[valve] = { ...parsedData[valve] };
      }
    });

    // Fill Technician Comments
    if (parsedData.technicianComments) {
      newFormData.technicianComments = { ...parsedData.technicianComments };
    }

    return newFormData;
  });
};


  if (!ismodal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50 overflow-y-auto min-h-screen px-2 py-6">
      <div className="w-full max-w-4xl text-start bg-white rounded-lg p-6 shadow-xl relative">
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-semibold">TRANSTHORACIC ECHOCARDIOGAPHY</h2>
          <button onClick={() => setIsmodal(false)} className="text-xl font-bold text-gray-500 hover:text-black">&times;</button>
        </div>
        <hr className="mb-4 border-gray-300" />

        {/* Patient Info */}
        <div className="flex items-center space-x-4 mb-4">
          <img src={`/cloud-assets/chim/public/assets/images/profilepictures/${data.patientid}.png`} alt="User" className="w-16 h-full max-h-28 rounded-md object-cover" />
          <div className="space-y-1">
            <div className="text-white bg-violet-500 rounded-lg px-1.5 py-0.5 text-xs font-medium inline-block">
              #{data?.patientid}
            </div>
            <div className="text-base font-semibold">{data?.firstname + " " + data?.lastname}</div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold">Date of Birth:</span> {formattedDOB}
            </div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold">Age:</span> {age} &nbsp;|&nbsp;
              <span className="font-semibold">Gender:</span> {data?.gender === "M" ? "Male" : "Female"}
            </div>
          </div>
        </div>





{prevExamData.length > 0 && (
<table className="min-w-full text-sm text-left border border-gray-300">
      
        <thead className="border bg-gray-200">
          <tr>
            <th colSpan="7" className="border px-3 py-2 font-semibold text-[#8B1818] text-center">Previous Exam Data</th>
          </tr>
          <tr>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">ID</th>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">Exam</th>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">Patient ID</th>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">Date of Service</th>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">Created By</th>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">Action</th>
          </tr>
        </thead>
      

      <tbody className="border divide-y divide-gray-200">
        {prevExamData.length > 0 ? (
          prevExamData.map((exam) => (
            <tr key={exam.id} className="border hover:bg-gray-50">
              <td className="border px-3 py-2">{exam.id}</td>
              <td className="border px-3 py-2">{exam.exam}</td>
              <td className="border px-3 py-2">{exam.patientid}</td>
              <td className="border px-3 py-2">{exam.dateofservice ? dayjs(exam.dateofservice).format("MM-DD-YYYY") : ""}</td>
              <td className="border px-3 py-2">{exam.createdby}</td>
              <td className="border px-3 py-2">
                  <AddBoxIcon onClick={() => handleFillFields(exam.data)} className="cursor-pointer text-gray-700 hover:text-gray-900" />
              </td>
            </tr>
          ))
        ) : (
          <tr>
              <td colSpan="7" className="border px-3 py-2 text-center text-gray-500">
                {loading ? "Getting Records ..." : " No records found"}
              </td>
          </tr>
        )}
      </tbody>
    </table>
)}





        {/* Form Fields */}
        <div className="grid grid-cols-4 gap-4 py-4">
          <div>
            <label className="block text-sm font-medium mb-1">Chart #</label>
            <input type="text" value={data?.patientid} readOnly className="border rounded px-2 py-1 w-full" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Take</label>
            <input type="text" value={formData.take} onChange={(e) => handleChange(e, 'take', 'take', e.target.value)} className="border rounded px-2 py-1 w-full" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Tape</label>
            <input type="text" value={formData.tape} onChange={(e) => handleChange(e, 'tape', 'tape', e.target.value)} className="border rounded px-2 py-1 w-full" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Date (MM/DD/YYYY)</label>
            <input type="date" value={formData.examDate} onChange={(e) => handleChange(e, 'examDate', 'examDate', e.target.value)} className="w-full border rounded px-2 py-1" />
          </div>
        </div>

        {/* Registered and Technician */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Registered by</label>
            <input type="text" value={formData.registeredby} onChange={(e) => handleChange(e, 'registeredby', 'registeredby', e.target.value)} className="w-full border rounded px-2 py-1" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Technician</label>
            <input type="text" value={formData.technician} onChange={(e) => handleChange(e, 'technician', 'technician', e.target.value)} className="w-full border rounded px-2 py-1" />
          </div>
        </div>

        {/* History */}
        <div className="mt-4">
          <label className="block text-sm font-medium">Patient History</label>
          <textarea
            placeholder="Enter Patient History here..."
            className="w-full border rounded px-2 py-1 mt-1"
            rows={3}
            value={formData.history}
            onChange={(e) => handleChange(e, 'history', 'history', e.target.value)}
          />
        </div>

        {/* M-Mode */}
        <div className="mt-4">
          <label className="block text-sm font-medium">M-Mode</label>
          <div className="overflow-x-auto">
            <table className="min-w-full table-auto border-separate border-spacing-0 border border-gray-300">
              <thead>
                <tr>
                  {mModeKeys.map(({ label }) => (
                    <th key={label} className="border p-1 text-center text-xs text-gray-500">{label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {mModeKeys.map(({ key }) => (
                    <td key={key} className="border-b text-center">
                      <input
                        type="text"
                        value={formData.mMode[key] || ''}
                        onChange={(e) => handleChange(e, 'mMode', key, e.target.value)}
                        className="w-full border px-2 py-1 text-center"
                      />
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <MitralAorticValves formData={formData} handleChange={handleChange} userConfig={userConfig}/>
        <TricuspidPulmonicForm formData={formData} handleChange={handleChange} userConfig={userConfig} />
        <TechnicalComments formData={formData} handleChange={handleChange} userConfig={userConfig} />

        <div className="py-8">
          <div className="flex justify-between items-center">
            <div>

        {allowedUsers.includes(userConfig?.username) ? (
          <div className="flex flex-col items-start p-4 bg-white shadow-md rounded-lg border border-gray-200 w-80">
            <label className="flex items-center cursor-pointer">
              <input
                type="checkbox"
                name="signoff"
                checked={formData.signoff || false}
                onChange={(e) => handleChange(e, null, "signoff")}
                className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              />
              <span className="ml-3 font-semibold text-gray-700 text-lg">Sign Off</span>
            </label>

            {formData.signoff && (
              <>
                <div className="mt-3 flex items-center space-x-3">
                  <img
                    src={DrMadhuSign}
                    alt="Signed Off"
                    className="h-20 rounded-lg shadow-md animate-fadeIn"
                  />
                  <span className="text-green-600 font-medium">Successfully Signed!</span>
                </div>
                <div className="py-2 font-semibold">Dr. Madhu Pamganamamula MD FACP FASPC DABOM DABCL CCD</div>
              </>
            )}
          </div>
        ) : (
          <div className=""></div>
        )}

            {/* <button className="text-blue-500 text-sm hover:text-blue-700">[ PRINT PREVIEW ]</button> */}
            </div>
            <div>
              <button onClick={handleSave} className="bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600">Save Report</button>
              {/* <button className="bg-green-500 text-white px-6 py-2 rounded-md hover:bg-green-600 ml-4">Update Report</button> */}
              <button onClick={resetFormData} className="bg-gray-500 text-white px-6 py-2 rounded-md hover:bg-gray-600 ml-4">Clear Data</button>
            </div>
          </div>
        </div>

        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: 'rgba(0, 0, 0, 0.7)', // reduced opacity
          }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={() => setOpenToast(false)}
        />
      </div>
    </div>
  );
};

export default EchoModal;